var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_2115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91658 9.99998C2.86174 10.0003 2.80738 9.98979 2.75662 9.96906C2.70585 9.94832 2.65968 9.91777 2.62075 9.87915C2.58169 9.84042 2.5507 9.79433 2.52954 9.74356C2.50839 9.69278 2.4975 9.63832 2.4975 9.58332C2.4975 9.52831 2.50839 9.47385 2.52954 9.42308C2.5507 9.3723 2.58169 9.32622 2.62075 9.28748L6.02491 5.88332C6.259 5.64895 6.39048 5.33124 6.39048 4.99999C6.39048 4.66874 6.259 4.35103 6.02491 4.11666L2.62075 0.712495C2.54229 0.634035 2.49821 0.527621 2.49821 0.416662C2.49821 0.305703 2.54229 0.199289 2.62075 0.120829C2.69921 0.0423693 2.80562 -0.00170898 2.91658 -0.00170898C3.02754 -0.00170898 3.13395 0.0423693 3.21241 0.120829L6.61658 3.52499C6.81059 3.71851 6.96452 3.94841 7.06955 4.20152C7.17458 4.45462 7.22864 4.72596 7.22864 4.99999C7.22864 5.27402 7.17458 5.54536 7.06955 5.79846C6.96452 6.05157 6.81059 6.28146 6.61658 6.47499L3.21241 9.87915C3.17348 9.91777 3.12731 9.94832 3.07654 9.96906C3.02578 9.98979 2.97142 10.0003 2.91658 9.99998Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_2115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.772ff0669b5c67fd21953cc73b80ef85.svg";
export { ForwardRef as ReactComponent };